<template>
  <z-chip
    class="mr-1"
    x-small
    :disabled="disabled"
    :close="value"
    :selected="value"
    :text="text"
    :icon="icon"
    :color="color"
    :icon-color="iconColor"
    @click:close="$emit('input', {id, value: false})"
    @click="$emit('input', {id, value: !value})"
  />
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },

    value: {
      type: Boolean,
      default: null,
    },

    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    configuration: {
      type: Object,
      default: () => ({}),
    },

    color: {
      type: String,
      default: 'var(--primary)',
    },
    iconColor: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
:deep(.v-chip__close) {
  font-size: 12px !important;
}
</style>
